import {useMutation, useQueryClient} from "@tanstack/react-query";
import {registerChileanRUTService} from "../services/account/registerChileanRUT.service";

// Mutation hook used by the Payku CLP withdrawal flow to persist the user's
// Chilean RUT (Keycloak attribute `nationalID_CL`). On success we invalidate
// `userData` so the next read picks up the new value and the form transitions
// from the registration step to the locked-RUT view.
const useRegisterChileanRUT = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: registerChileanRUTService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userData"]});
    },
  });
};

export default useRegisterChileanRUT;
